import { useAppSelector } from 'hooks/reduxHooks'
import { getFlightDealMemberPrice } from 'lib/flights/flightDealPricing'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'

export function useFlightMemberPrice(price: number, memberPrice?: number | null): number | undefined {
  const luxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)
  return luxPlusEnabled
    ? getFlightDealMemberPrice({ perAdultPrice: price, luxPlusPerAdultPrice: memberPrice })
    : undefined
}
